export default {
  name: 'ztyj',
  components: {},
  data () {
    return {
      ztyjList: [
        {
          name: '红色文化研究',
          code: 'hswh'
        }, {
          name: '雨花英烈研究',
          code: 'yhyl'
        }, {
          name: '综合管理研究',
          code: 'zhgl'
        }
      ],
      selectCode: 'hswh'
    }
  },
  // 创建元素
  mounted () {
  },
  // 方法定义
  methods: {
    // 鼠标移入
    moveItem (item) {
      this.selectCode = item.code
    },

    // 点击进入详情
    goModule (item) {
      // new 代码
      let yjzt = {}
      switch (item.code) {
        case 'hswh':
          yjzt = this.$router.resolve({
            path: '/redCulture',
            query: {
              module: item.code
            }
          })
          break
        case 'yhyl':
          yjzt = this.$router.resolve({
            path: '/rainHero',
            query: {
              module: item.code
            }
          })
          break
        case 'zhgl':
          yjzt = this.$router.resolve({
            path: '/zhglyj',
            query: {
              module: item.code
            }
          })
          break
      }
      // old 代码
      // const yjzt = this.$router.resolve({
      //   path: '/yjztModule',
      //   query: {
      //     module: item.code
      //   }
      // })
      window.open(yjzt.href, '_blank')
    }
  }
}
